/** Central tunables. Gameplay should read from here, not hardcode numbers. */
export const CONFIG = {
  /** Source tile size in px (matches the Sprout Lands pack). */
  tileSize: 16,

  /** Default integer camera zoom; clamped per device in WorldScene. */
  defaultZoom: 3,
  minZoom: 2,
  maxZoom: 5,
  /** Aim for roughly this many tiles across the short screen axis (→ zoom 3 on a phone). */
  targetTilesAcross: 9,

  /** Real seconds that elapse per in-game minute. Lower = faster days. */
  realSecondsPerGameMinute: 0.6,

  /** Each point of energy spent also advances the clock this many in-game minutes —
   *  blends time with effort, so a busy session naturally reaches evening as you tire. */
  gameMinutesPerEnergy: 9,

  /** Day starts at 6:00am; forced collapse at 2:00am. */
  dayStartHour: 6,
  forceSleepHour: 2,

  /** Energy is generous — cozy, not punishing — but visibly drains over a day. */
  energyMax: 110,
  energyCosts: {
    till: 3,
    plant: 1,
    water: 1,
    harvest: 1,
    chop: 5,
    pullWeed: 2,
    milk: 2,
    mine: 4,
    fish: 2,
    forage: 1,
  },

  /** Economy. */
  startingMoney: 200,

  /** Weeds spawn overnight on open grass; clear them to keep the farm tidy. */
  weedsPerDay: 3,
  weedCap: 16,

  /** Days per season (Spring→Winter); a year is 4× this. Relaxed pace. */
  daysPerSeason: 12,

  /** Player path-walk speed in tiles/second. */
  walkTilesPerSecond: 4.5,

  /** Pet follow behaviour. */
  petFollowGapTiles: 1.4,
  petSpeedTilesPerSecond: 5,

  /** Clara wander behaviour. */
  claraWanderRadiusTiles: 4,
  claraStepChancePerSecond: 0.5,

  /** Debug overlay: taps on the top-left corner to open it (touch-accessible). */
  debugCornerTaps: 5,
  debugCornerSizePx: 64,
} as const;

export type EnergyAction = keyof typeof CONFIG.energyCosts;
